import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-close-small',
  templateUrl: './icon-close-small.component.html',
  styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconCloseSmallComponent {
    @Input() isActive: boolean = false;
}
